var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-wrapper"},[_vm._m(0),_c('div',[_c('Education')],1),_vm._m(1),_c('div',[_c('WorkExperience')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-header"},[_vm._v(" EDUCATION "),_c('hr',{staticClass:"line"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-header"},[_vm._v(" WORK EXPERIENCE "),_c('hr',{staticClass:"line"})])
}]

export { render, staticRenderFns }